import {
  DEMO_TURMA_DISC,
  DEMO_TURMA_DISC_CI,
  DEMO_TURMA_DISC_MAT
} from "./buildDemoOccurrences";

const DEMO_PERIODS = [
  { code: "1TRI", name: "1º Trimestre" },
  { code: "2TRI", name: "2º Trimestre" },
  { code: "3TRI", name: "3º Trimestre" }
];

const DEMO_DISCIPLINE_NAMES = {
  [DEMO_TURMA_DISC]: "Português — demonstração",
  [DEMO_TURMA_DISC_MAT]: "Matemática — sem acesso (demo)",
  [DEMO_TURMA_DISC_CI]: "Ciências — sem acesso (demo)"
};

export const buildDemoClassStageConcepts = () => ({
  groupId: "1",
  groupTitle: "Conceito (1°/EF)",
  concepts: [
    { code: "E", minGrade: 9, maxGrade: 10 },
    { code: "CMB", minGrade: 7.6, maxGrade: 8.9 },
    { code: "CB", minGrade: 6, maxGrade: 7.5 },
    { code: "A", minGrade: 4, maxGrade: 5.9 },
    { code: "I", minGrade: 0, maxGrade: 3.9 }
  ]
});

const buildConcepts = (subject, action) => [
  {
    code: "E",
    description: `${action} ${subject} com autonomia e intencionalidade.`
  },
  { code: "CMB", description: `${action} ${subject} observando os efeitos.` },
  { code: "CB", description: `${action} ${subject}.` },
  {
    code: "A",
    description: `Explora ${subject}, mas ainda não consegue ${action.toLowerCase()}.`
  },
  {
    code: "I",
    description: `Ainda não consegue ${action.toLowerCase()} ${subject}.`
  }
];

const demoLink = (rowId, idTurmaDisc, classCode) => ({
  rowId: String(rowId),
  idTurmaDisc: String(idTurmaDisc),
  classCode,
  disciplineName: DEMO_DISCIPLINE_NAMES[idTurmaDisc] || String(idTurmaDisc)
});

let demoStages = null;
let nextDemoRowId = 100;

const seedDemoStages = classId => [
  {
    id: "1",
    stageCode: "901",
    periodCode: "1TRI",
    title: "Arts Skills and Reflection",
    description:
      "Percebe e representa o resultado de suas investigações sobre o corpo humano explorando diferentes materiais.",
    concepts: buildConcepts("o corpo humano", "Representa"),
    links: [demoLink(1, DEMO_TURMA_DISC, classId)]
  },
  {
    id: "2",
    stageCode: "902",
    periodCode: "1TRI",
    title: "Movement and Body Awareness",
    description:
      "Desloca-se no espaço mudando de posição e realiza arremessos acima da cabeça.",
    concepts: buildConcepts("os movimentos propostos", "Executa"),
    links: [
      demoLink(2, DEMO_TURMA_DISC_MAT, classId),
      demoLink(3, DEMO_TURMA_DISC_CI, "DEMO-T2")
    ]
  }
];

const withPeriodName = stage => {
  const period = DEMO_PERIODS.find(item => item.code === stage.periodCode);
  return { ...stage, periodName: period ? period.name : "" };
};

export const buildDemoClassStages = classId => {
  if (!demoStages) demoStages = seedDemoStages(classId);
  return {
    periods: DEMO_PERIODS,
    stages: demoStages
      .filter(stage => stage.links.some(link => link.classCode === classId))
      .map(withPeriodName)
  };
};

export const saveDemoClassStage = (classId, payload) => {
  if (!demoStages) demoStages = seedDemoStages(classId);
  const existing = demoStages.find(stage => stage.id === String(payload.id));
  const previousLinks = new Map(
    (existing ? existing.links : []).map(link => [link.idTurmaDisc, link])
  );
  const links = (payload.links || []).map(link => {
    const idTurmaDisc = String(link.idTurmaDisc);
    if (previousLinks.has(idTurmaDisc)) return previousLinks.get(idTurmaDisc);
    nextDemoRowId += 1;
    return demoLink(nextDemoRowId, idTurmaDisc, link.classId);
  });
  const stage = {
    id: existing ? existing.id : String(nextDemoRowId),
    stageCode: existing
      ? existing.stageCode
      : String(900 + demoStages.length + 1),
    periodCode: payload.periodCode,
    title: payload.title,
    description: payload.description || "",
    concepts: (payload.concepts || []).filter(concept => concept.description),
    links
  };
  demoStages = existing
    ? demoStages.map(item => (item.id === existing.id ? stage : item))
    : demoStages.concat(stage);
  return { id: stage.id };
};
